import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import Carrusel from '../_app/cuchillo/components/Carrusel';
import { GetBy } from '../_app/cuchillo/core/Element';
import gsap from 'gsap';

class ScrollItem__ClientLogos extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._carrusel = new Carrusel(Metrics.WIDTH, GetBy.class("__carrusel", this.item)[0], GetBy.class("__carrusel", this.item)[1]);
        this._carrusel.multiplicator = .1;
        this._call = () => this.loop();

        this.onShow = () => {
            gsap.ticker.add(this._call);
        };

        this.onHide = () => {
            gsap.ticker.remove(this._call);
        };
    }

    loop() {
        this._carrusel.loop();
    }

    dispose() {
        super.dispose();
        gsap.ticker.remove(this._call);
        this._carrusel.dispose();
    }
}

Scroll._registerClass('client-logos', ScrollItem__ClientLogos);

export default ScrollItem__ClientLogos;
